import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "reports" }
const _hoisted_2 = { class: "search-bar d-flex" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "reports-table table-responsive mt-2 mb-3" }
const _hoisted_5 = { class: "table table-hover table-admin overflow-hidden rounded-1" }
const _hoisted_6 = { class: "table-registry border-3 border-primary" }
const _hoisted_7 = { class: "align-middle" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "fw-bold m-0 text-white" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = ["fill"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", { d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["fill"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", { d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "overflow-hidden border-3 border-primary border-top-0 border-bottom-0 rounded-1" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "align-middle border-3 border-start-0 border-end-0 border-primary"
}
const _hoisted_21 = ["colspan"]
const _hoisted_22 = {
  class: "modal fade",
  id: "viewReport",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "viewReportLabel",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h1", {
    class: "modal-title fs-6 fw-semibold",
    id: "viewReportLabel"
  }, " Report Details "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_26 = { class: "modal-body" }
const _hoisted_27 = { class: "row m-1 text-start" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Report ID")
], -1)
const _hoisted_29 = { class: "col-12 col-sm" }
const _hoisted_30 = { class: "text-start" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Violator Name")
], -1)
const _hoisted_33 = { class: "col-12 col-sm" }
const _hoisted_34 = { class: "text-start" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Reporter Name")
], -1)
const _hoisted_37 = { class: "col-12 col-sm" }
const _hoisted_38 = { class: "text-start" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Anonymous?")
], -1)
const _hoisted_41 = { class: "col-12 col-sm" }
const _hoisted_42 = { class: "text-start" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Report Type")
], -1)
const _hoisted_45 = { class: "col-12 col-sm" }
const _hoisted_46 = { class: "text-start" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Report Subject")
], -1)
const _hoisted_49 = { class: "col-12 col-sm" }
const _hoisted_50 = { class: "text-start" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Description")
], -1)
const _hoisted_53 = { class: "col-12 col-sm" }
const _hoisted_54 = { class: "text-justify" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer d-flex flex-column flex-sm-row justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-dark rounded-0 px-3 py-2",
    "data-bs-dismiss": "modal"
  }, " Manage User "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary rounded-0 px-3 py-2"
  }, " Mark Resolved "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-danger rounded-0 px-3 py-2",
    "data-bs-dismiss": "modal"
  }, " Delete Report ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "text",
        class: "form-control bg-transparent text-white px-4 py-3 border-3 border-primary rounded-top-4",
        placeholder: "Search here...",
        id: "searchBar",
        value: _ctx.searchText,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSearchText($event.target.value)))
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", _hoisted_6, [
          _createElementVNode("tr", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
              return (_openBlock(), _createElementBlock("th", {
                key: index,
                class: "sorting-column py-2",
                scope: "col"
              }, [
                (header.key !== 'actions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn w-100 d-flex flex-row align-items-center justify-content-center gap-3",
                        onClick: ($event: any) => (_ctx.setFilterBy(header.key)),
                        ref_for: true,
                        ref: `sortBy${
                    header.key.charAt(0).toUpperCase() + header.key.slice(1)
                  }`
                      }, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(header.label), 1),
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "14",
                            height: "14",
                            fill: 
                        _ctx.filterBy === header.key && _ctx.ascending
                          ? '#6ef997'
                          : '#adb5bd'
                      ,
                            class: "bi bi-caret-up-fill",
                            viewBox: "0 0 16 16"
                          }, _hoisted_14, 8, _hoisted_12)),
                          (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "14",
                            height: "14",
                            fill: 
                        _ctx.filterBy === header.key && !_ctx.ascending
                          ? '#6ef997'
                          : '#adb5bd'
                      ,
                            class: "bi bi-caret-down-fill",
                            viewBox: "0 0 16 16"
                          }, _hoisted_17, 8, _hoisted_15))
                        ])
                      ], 8, _hoisted_9)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_18, [
          (_ctx.filteredReports.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filteredReports, (report) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: report.reportId,
                  class: "report align-middle border-3 border-start-0 border-end-0 border-primary"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (header.key === 'actions')
                        ? (_openBlock(), _createElementBlock("td", {
                            key: index,
                            class: "text-center py-2"
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-primary rounded-0 px-4 py-3",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#viewReport",
                              onClick: ($event: any) => (_ctx.setSelectedReport(report))
                            }, " View ", 8, _hoisted_19)
                          ]))
                        : (_openBlock(), _createElementBlock("td", {
                            key: index,
                            class: "text-center"
                          }, _toDisplayString(report[header.key]), 1))
                    ], 64))
                  }), 256))
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                _createElementVNode("td", {
                  class: "py-3",
                  colspan: _ctx.headers.length
                }, "No reports found.", 8, _hoisted_21)
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.selectedReport.reportId), 1)
              ]),
              _hoisted_31,
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.selectedReport.violatorName), 1)
              ]),
              _hoisted_35,
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.selectedReport.reporterName), 1)
              ]),
              _hoisted_39,
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.selectedReport.anonymous ? "Yes" : "No"), 1)
              ]),
              _hoisted_43,
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.selectedReport.reportType), 1)
              ]),
              _hoisted_47,
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.selectedReport.subject), 1)
              ]),
              _hoisted_51,
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.selectedReport.message), 1)
              ])
            ])
          ]),
          _hoisted_55
        ])
      ])
    ])
  ]))
}